<div class="multiple-sclerosis" #scrollContainer>
  <nz-layout>
    <nz-header>
      {{ "Multiple Sclerosis Segmentation" | translate }}
    </nz-header>
    <nz-content>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
        <div fxLayout="column" fxFlex="80">
          <nz-select type="multiple" nzShowSearch nzAllowClear [nzPlaceHolder]="
              'Select Imaging Record to be segmented' | translate
            " [nzOptions]="imagingRecords" [(ngModel)]="selectedImaging" [disabled]="!hasPermission(['a-mss'])">
          </nz-select>
        </div>
        <div fxLayout="column" fxFlex="20" *hasAddPermissions="['a-mss']">
          <button nz-button (click)="segment()" [disabled]="
              (!selectedImaging || isLoading)
            ">
            {{ "Segment" | translate }}
          </button>
        </div>
      </div>

      <div>
        @if (isLoading) {
          <div fxLayout="row" fxLayoutAlign="center center" class="ms-spinner">
            <nz-spin nzSimple></nz-spin>
          </div>
        }
        @if (segmentationResult?.creationDate) {
          <div class="creation-date" fxLayoutAlign="center center">
            <div>
              {{ "Creation Date" | translate }}:
              {{ segmentationResult?.creationDate | date : date_format_html }}
            </div>
          </div>
        }
        @for (result of segmentationResult?.predictionAiResponse; track result) {
          <div fxLayout="row" fxLayoutAlign="center center" class="segmentation-results">
            <div fxLayout="column" fxFlex="30">
              <div fxLayoutAlign="center center">
                {{ "Processed Image" | translate }}
              </div>
              <img nz-image [nzSrc]="'data:image/png;base64,' + result.processedImage" nzWidth="auto" nzHeight="auto"
                class="result-img" />
              </div>
              <div fxLayout="column" fxFlex="5"></div>
              <div fxLayout="column" fxFlex="30">
                <div fxLayoutAlign="center center">
                  {{ "Prediction Mask" | translate }}
                </div>
                <img nz-image [nzSrc]="'data:image/png;base64,' + result.predictionImage" nzWidth="auto" nzHeight="auto"
                  class="result-img" />
                </div>
                <div fxLayout="column" fxFlex="5"></div>
                <div fxLayout="column" fxFlex="30">
                  <div fxLayoutAlign="center center">
                    {{ "Overlay" | translate }}
                  </div>
                  <img nz-image [nzSrc]="'data:image/png;base64,' + result.contourImage" nzWidth="auto" nzHeight="auto"
                    class="result-img" />
                  </div>
                </div>
              }
            </div>
          </nz-content>
        </nz-layout>
      </div>